module.exports = __webpack_public_path__ + "8a3ace70f80f5570c63b1b1b0e342c73.pdf";